// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__2q1lx"};